import * as React from "react";
const SvgSecure = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={14}
    fill="none"
    {...props}
  >
    <path
      fill="#89909D"
      d="M11.396 5.271v-.875C11.396 2.506 10.941 0 7 0S2.604 2.506 2.604 4.396v.875C.644 5.516 0 6.51 0 8.953v1.302C0 13.125.875 14 3.745 14h6.51c2.87 0 3.745-.875 3.745-3.745V8.953c0-2.443-.644-3.437-2.604-3.682M7 11.718a2.117 2.117 0 0 1-2.114-2.114c0-1.169.952-2.114 2.114-2.114s2.114.952 2.114 2.114A2.11 2.11 0 0 1 7 11.718m-3.255-6.51h-.161v-.812C3.584 2.345 4.165.98 7 .98s3.416 1.365 3.416 3.416v.819H3.745z"
    />
  </svg>
);
export default SvgSecure;
